import type { PropsWithChildren } from 'react'
import { useConnectorConnectedToast } from '@/components/hooks/useConnectorConnectedToast'
import { useRouteProtection } from '@/components/hooks/useRouteProtection'

export const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { isDataLoading, shouldBlockContent } = useRouteProtection()

  useConnectorConnectedToast()

  if (isDataLoading || shouldBlockContent) {
    return <></>
  }

  return <>{children}</>
}
